export default "__VITE_ASSET__CO9EwtM6__"